<template>
  <div v-if="checkVariable(signature_generation_process)">
    <transition name="fade" mode="out-in">
      <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="accountTerminatedChanged" @dismiss-count-down="countDownChanged">
        <h3 class="alert-heading">{{ signature_generation_process.name }}</h3>
        <p class="lead">{{ signature_generation_process.description }}</p>
        <small>Esta alerta se descartará después de {{ dismissCountDown }} segundos...</small>
        <template v-if="checkVariable(signature_generation_process.values) && isArray(signature_generation_process.values)">
          <v-img-lazy
            :mainProps="{ thumbnail: true, fluid: true, blank: true }"
            :uris="signature_generation_process.values"
            v-on:click.native.prevent="storeSelectedSignature"
          ></v-img-lazy>
        </template>
        <template v-if="checkVariable(signature_generation_process.routeClient) && isObject(_noReactive(signature_generation_process.routeClient))">
          <hr>
          <a class="btn btn-link" v-on:click="goResource(signature_generation_process.routeClient)">
            {{ $t('go_resource') }}
          </a>
        </template>
      </b-alert>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import Imagen from './ImagenSrc'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'vue-showalert',
  components: {
    'v-img-lazy': Imagen,
  },
  computed: {
    ...mapGetters({
      'signature_generation_process': 'signature_generation_process',
      'select_resource_signature_generation_process': 'select_resource_signature_generation_process',
    }),
  },
  data() {
    return {
      dismissCountDown: 0,
    }
  },
  watch: {
    'signature_generation_process': {
      deep: true,
      handler() {
        this.dismissCountDown = (this.checkVariable(this.signature_generation_process.values)) ? 50 : 15
      },
    },
    dismissCountDown: {
      handler(dismissCountDown) {
        localStorage.setItem('dismissCountDown', JSON.stringify(dismissCountDown))
      },
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      const dismissCountDown = localStorage.getItem('dismissCountDown')
      if (this.checkVariable(dismissCountDown) && this.dismissCountDown === 0) {
        this.dismissCountDown = parseInt(dismissCountDown)
      }
    })
  },
  methods: {
    _noReactive(router) {
      return JSON.parse(router)
    },
    accountTerminatedChanged() {
      this.dismissCountDown = 0
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    async storeSelectedSignature(e) {
      e.preventDefault()

      this.$emit('eventStoreSelection', {
        'selected': this.select_resource_signature_generation_process,
        'route_server': this.signature_generation_process.routeServer,
        'route_client': this.signature_generation_process.routeClient,
      })
    },
  },
}
</script>
